import * as React from 'react';
import { Banner } from '@/components/ui/banner';

export const PendingResearchBanner: React.FC = () => (
  <Banner
    tone="caution"
    title="Verifying Contact Details"
    line="We are locating the verified address and will send this notification within 24 hours. You'll receive an email notification once this has been sent."
  />
);
